import { controlClose, focusNextControlTrigger } from '../../../../resources/scripts/components/c-common';

export default function () {
  function ignoreWidgetFocusoutOnTouch(control) {
    const widget = control?.closest('.js-booking-widget');
    if (!widget) {
      return;
    }

    widget.dataset.bookingWidgetIgnoreFocusout = '1';
    window.setTimeout(() => {
      delete widget.dataset.bookingWidgetIgnoreFocusout;
    }, 500);
  }

  function save(control, value) {
    const widget = control.closest('.js-booking-widget');
    const badge = widget.querySelector('.js-badge-destination');
    const trigger = control.querySelector('.js-control-trigger');
    trigger.textContent = value;
    badge.textContent = value;
    controlClose(control);
    focusNextControlTrigger(control);
  }

  function setBookingParams(control, event) {
    const { target } = event;

    try {
      let newTarget;

      if (target.classList.contains('js-destination-property')) {
        newTarget = target;
      } else {
        newTarget = target.closest('.js-destination-property');
      }

      const {
        bookingEngine,
        hotelCode,
        triplaCode,
        synxisConfig,
        synxisLevel,
      } = newTarget.dataset;
      const bookingWidgetBookingEngine = control.querySelector('.js-destination-booking-engine');
      const bookingWidgetHotelCode = control.querySelector('.js-destination-hotel-code');
      const bookingWidgetTriplaCode = control.querySelector('.js-destination-tripla-code');
      const bookingWidgetSynxisConfig = control.querySelector('.js-destination-synxis-config');
      const bookingWidgetSynxisLevel = control.querySelector('.js-destination-synxis-level');
      bookingWidgetBookingEngine.value = bookingEngine;
      bookingWidgetHotelCode.value = hotelCode;

      if (bookingWidgetTriplaCode) {
        bookingWidgetTriplaCode.value = triplaCode || '';
      }

      if (bookingWidgetSynxisConfig) {
        bookingWidgetSynxisConfig.value = synxisConfig || '';
      }

      if (bookingWidgetSynxisLevel) {
        bookingWidgetSynxisLevel.value = synxisLevel || 'hotel';
      }
    } catch (e) {
      console.error(e);
    }
  }

  const properties = window.document.querySelectorAll('.js-destination-property');
  properties.forEach((property) => {
    property.addEventListener('touchstart', (event) => {
      const control = event.target.closest('.js-control');
      if (control) {
        ignoreWidgetFocusoutOnTouch(control);
      }
    }, { passive: true });

    property.addEventListener('click', (event) => {
      event.preventDefault();
      const { target } = event;
      const control = target.closest('.js-control');

      if (control) {
        save(control, target.textContent);
        setBookingParams(control, event);
      }
    });
  });
}
